import Entity from './entity'
export default class Threshold extends Entity<number>{
    sName:string;
}